module.exports = __webpack_public_path__ + "static/media/tasks-solid.068c129f.svg";